<template>
  <div class="text-center">
    <v-icon
      v-for="item in [1, 2, 3, 4, 5]"
      :key="item"
      class="mx-2 cursor-pointer"
      :class="{
        hovered: item <= hovered
      }"
      size="28"
      @mouseover="mouseEnter(item)"
      @mouseleave="mouseLeave"
      @click="$emit('clickRating', item)"
    >
      {{ item <= rating ? '$starFilled' : '$star' }}
    </v-icon>
  </div>
</template>

<script>
export default {
  name: 'RatingStars',
  props: {
    rating: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      hovered: 0
    };
  },
  methods: {
    mouseEnter(item) {
      this.hovered = item;
    },
    mouseLeave() {
      this.hovered = 0;
    }
  }
};
</script>

<style lang="scss" scoped>
.hovered {
  color: $black;
}
</style>
